import React from "react"
import type { PropsWithChildrenAndStyle } from "@mallardbay/lib-react-components"
import {
    componentStyles,
    Card as SharedCard,
} from "@mallardbay/lib-react-components"

// TODO: Consolidate with shared lib card

interface Props extends PropsWithChildrenAndStyle {
    readonly noPadding?: boolean
    readonly testId?: string
    readonly height?: string
    readonly onClick?: () => void
}

export default function Card({
    style,
    noPadding,
    children,
    testId,
    height,
    onClick,
}: Props) {
    const styles = useStyles({
        noPadding,
        height,
    })

    return (
        <SharedCard
            style={{ ...style, ...styles.root }}
            testId={testId}
            onClick={onClick}
        >
            {children}
        </SharedCard>
    )
}

function useStyles({
    noPadding,
    height,
}: {
    noPadding?: boolean
    height?: string
}) {
    return componentStyles({
        root: {
            borderRadius: "xl",
            backgroundColor: "none",
            padding: noPadding ? 0 : undefined,
            height,
            marginTop: 6,
        },
    })
}
